export default __webpack_public_path__ + "static/media/icon-seventh-smoke.3e13b211.svg";